/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'
import PressCard from '~/components/Press/Card'

const PressListSection = ({ cta, description, press, title }) => {
  return (
    <Box bg="backgroundMedium" pt={[7, null, 9]} pb={[8, null, 10]}>
      <Container>
        <Heading as="h2" variant="title2" mb={5} sx={{ textAlign: 'center' }}>
          {title}
        </Heading>
        <Grid columns={[1, 2, 3]}>
          {press.map((pressItem, index) => (
            <Box key={`press-${index}`}>
              <PressCard press={pressItem} />
            </Box>
          ))}
        </Grid>
        {description && (
          <Box
            dangerouslySetInnerHTML={{
              __html: description.childMarkdownRemark.html,
            }}
            mt={7}
            variant="text.body1"
            sx={{
              textAlign: 'center',
              p: {
                my: 1,
              },
            }}
          />
        )}
        {cta && (
          <Box mt={4} sx={{ textAlign: 'center' }}>
            {cta}
          </Box>
        )}
      </Container>
    </Box>
  )
}

export default PressListSection
